import i18n from "i18next";
import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  HiOutlineKey,
  HiOutlineLogout,
  HiOutlineUser,
  HiOutlineViewGrid,
} from "react-icons/hi";
import { useDispatch } from "react-redux";

// import { getFileName } from "@/helper";
import USFlag from "@/assets/images/en.png";
import KhmerFlag from "@/assets/images/kh.png";
import Lucide from "@/components/Base/Lucide";
// import None from "@/assets/images/default.jpg";
import { Menu, Slideover } from "@/components/Base/Headless";
import { logout } from "@/stores/authSlice.ts";
import { useAppSelector } from "@/stores/hooks.ts";
import { AppDispatch } from "@/stores/store.ts";
import { getAccessibleAppsCount } from "@/utils/appAccess";
import { getToken } from "@/utils/helper.ts";
// import { FreeItem } from "@/services/ServiceApi";

interface TopBarProps {
  children?: ReactNode;
}

function Main({ children }: TopBarProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const user = useAppSelector((state) => state.auth.user);
  const accessibleAppsCount = getAccessibleAppsCount(user?.role?.permissions);

  const [slideRequest, setSlideRequest] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
  };

  const handleSwitchApp = () => {
    const token = getToken();
    const loginUrl = import.meta.env.VITE_LOGIN_URL;
    if (!loginUrl || !token) return;
    window.location.href = `${loginUrl}/select-app?token=${encodeURIComponent(token)}`;
  };

  return (
    <>
      <div className="min-h-[70px] md:h-[70px] z-[51] flex flex-col md:flex-row items-stretch md:items-center gap-2 md:gap-4 md:justify-evenly border-b border-slate-200 bg-white w-full md:w-[calc(100%+44px)] md:-mx-[22px] py-2 md:py-0">
        <div className="order-2 md:order-1 w-full md:flex-1 flex items-center px-2 md:px-[30px] overflow-x-auto">
          {children}
        </div>

        <div className="order-1 md:order-2 w-full md:w-auto flex items-center justify-start md:justify-normal gap-5 px-5 md:px-[42px]">
          {/* <Menu>
                        <Menu.Button
                            onClick={() => setSlideRequest(true)}
                            className="size-8 rounded-full bg-gray-100 flex items-center justify-center relative">
                            <HiOutlineBell className="text-gray-400" size={20} />

                            <span className={`
                                    absolute top-0 right-0 -mt-1 -mr-1 bg-red-500 text-white  font-medium rounded-full flex items-center justify-center h-4 w-4 text-[10px]
                                    ${count > 9 ? "h-[1.1rem] w-[1.1rem] top-[-0.2rem]" : ""}
                                    ${count > 99 ? "h-[1.3rem] w-[1.3rem] top-[-0.4rem]" : ""}
                                `}>
                                {count > 99 ? '+99' : count}
                            </span>
                        </Menu.Button>
                    </Menu> */}
          <Menu>
            <Menu.Button className="h-8 w-full flex rounded-full gap-x-2">
              <div className="size-8 rounded-full bg-gray-100 flex items-center justify-center">
                <HiOutlineUser className="text-gray-400" size={20} />
              </div>
              <div className="flex flex-col items-start">
                <span className="text-gray-800">
                  {" "}
                  {user.fullName ? user.fullName : "Default"}
                </span>
                <span className="text-gray-400 text-xs">{t("waiter")}</span>
              </div>
            </Menu.Button>
            <Menu.Items
              className="w-52 md:w-56 mt-2 text-gray-500 bg-white"
              placement="bottom-end"
            >
              <Menu.Header className="font-normal">
                <span className="font-medium">
                  {user.fullName ? user.fullName : "Default"}
                </span>
                <br />
                <span className="text-xs text-black/70 mt-0.5 dark:text-slate-500">
                  {user.email ? user.email : "default@gmail.com"}
                </span>
              </Menu.Header>
              <Menu.Divider className="bg-black/[0.08]" />
              <Menu.Item
                className="hover:bg-black/5"
                onClick={() => i18n.changeLanguage("en")}
              >
                <img alt="kh-flag" src={USFlag} className="h-6 w-6 mr-3" />
                English
              </Menu.Item>
              <Menu.Item
                className="hover:bg-black/5"
                onClick={() => i18n.changeLanguage("kh")}
              >
                <img alt="us-flag" src={KhmerFlag} className="h-6 w-6 mr-3" />
                ភាសាខ្មែរ
              </Menu.Item>
              <Menu.Divider className="bg-black/[0.08]" />
              <Menu.Item className="hover:bg-black/5" onClick={handleLogout}>
                <HiOutlineKey className="mr-2" size={24} />
                {t("changePassword")}
              </Menu.Item>
              {accessibleAppsCount > 1 && (
                <Menu.Item
                  className="hover:bg-black/5"
                  onClick={handleSwitchApp}
                >
                  <HiOutlineViewGrid className="mr-2" size={24} />
                  {t("switchApp")}
                </Menu.Item>
              )}
              <Menu.Item className="hover:bg-black/5" onClick={handleLogout}>
                <HiOutlineLogout className="mr-2" size={24} />
                {t("logout")}
              </Menu.Item>
            </Menu.Items>
          </Menu>
        </div>
      </div>

      <Slideover
        className="overflow-hidden"
        size="lg"
        open={slideRequest}
        onClose={() => setSlideRequest(false)}
      >
        <Slideover.Panel className="h-full flex flex-col">
          <Slideover.Description className="flex flex-col h-full">
            {/* Header */}
            <div className="intro-y border-b pb-4 border-slate-200/60">
              <Lucide
                icon="X"
                className="w-7 h-7 border rounded-full p-1 text-red-600 zoom-in hover:cursor-pointer"
                onClick={() => setSlideRequest(false)}
              />
              <div className="mt-5 flex justify-between">
                <div className="text-lg font-medium mr-auto">
                  {t("freeItems")}
                </div>
              </div>
            </div>
          </Slideover.Description>
        </Slideover.Panel>
      </Slideover>
    </>
  );
}

export default Main;
